module.exports = __webpack_public_path__ + "static/img/2.5373da3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/2.png
// module id = +PBy
// module chunks = 0